@if (message) {
    <div class="message-wrapper">
        <nz-comment
            [nzAuthor]="message.senderName"
            [nzDatetime]="message.date ? message.date : ''">
            <nz-comment-content>
                @if (message.docUrl) {
                  @switch (attachment.kind) {
                    @case ('image') {
                      <a [href]="message.docUrl" target="_blank" rel="noopener noreferrer">
                        <img [src]="message.docUrl" [alt]="attachmentName" style="max-height: 200px; max-width: 100%;" />
                      </a>
                    }
                    @case ('audio') {
                      <audio controls preload="none" [src]="message.docUrl" style="max-width: 100%;" aria-label="WhatsApp audio"></audio>
                    }
                    @case ('video') {
                      <video controls playsinline preload="none" [src]="message.docUrl" style="max-height: 300px; max-width: 100%;" aria-label="WhatsApp video"></video>
                    }
                    @default {
                      <p><nz-icon [nzType]="attachment.isPdf ? 'file-pdf' : 'file'" /> {{ attachmentName }}</p>
                    }
                  }
                  <p><a [href]="message.docUrl" target="_blank" rel="noopener noreferrer">Open / download attachment</a></p>
                } @else if (message.documentId) {
                  <p>Attachment is no longer available.</p>
                }
                <div class="message-bubble">
                  @if (message.incidentId === 0) {
                    <nz-tag 
                      nzColor="red" 
                      (click)="onClickRemoveMessage()"
                      style="position: absolute; top: 8px; right: -24px; cursor: pointer; z-index: 10; border-radius: 50%; padding: 4px 8px;"
                      nz-tooltip="Remove message">
                      <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                  </nz-tag>
                  }

                    @if (caption.startsWith('http://') || caption.startsWith('https://')) {
                        <p><a [href]="caption" target="_blank" rel="noopener noreferrer">{{ caption }}</a></p>
                    }
                    @else {
                        <p>{{ caption }}</p>
                    }
                </div>
                @if (message.receiverName) {
                <div class="receiver-name">
                    <p>Received by {{ message.receiverName }}</p>
                </div>
                }
                @if (message.incidentId === 0 ) {
                  <!-- ACTION BUTTONS -->
                  @if (message.messageType === socketMessageType.WhatsappIncident) {                  
                    <button nz-button [nzType]="'primary'" nzSize="small" (click)="onClickCreateNewIncident()" style="margin: 5px;">{{sharedDataService.selectedMessages.length > 0 ? 'Add To New Breakdown' : 'Create New Breakdown'}}</button>
                    
                  }
                  @if ((message.messageType === socketMessageType.ProofOfWorkDocument || message.messageType === socketMessageType.WhatsappIncident || message.messageType === socketMessageType.WhatsappOther) && whatsappService.currentIncidentId()) {
                    <button nz-button [nzType]="'primary'" nzSize="small" (click)="onClickLinkToCurrentOpen()" style="margin: 5px;">Link To This Breakdown</button>
                    
                  }
                  @if (message.messageType !== socketMessageType.IncidentLocationUpdate && !whatsappService.currentIncidentId()) {
                    <button nz-button [nzType]="'primary'" nzSize="small" (click)="onClickAddToIncident()" style="margin: 5px;">Search For Breakdown</button>
                  }
                  
                }
                @if (message.messageType === socketMessageType.IncidentLocationUpdate && isItThisIncident() === false) {
                  <button nz-button [nzType]="'primary'" nzSize="small" (click)="onClickViewIncident()" style="margin: 5px;">View Breakdown</button>
                }
                @if (message.messageType === socketMessageType.IncidentLocationUpdate && isItThisIncident() === true) {
                  Viewing Incident...
                }
            </nz-comment-content>
        </nz-comment>
    </div>
}


  <nz-modal [(nzVisible)]="isSearchForIncidentModalVisible" nzTitle="Search for Breakdown" (nzOnCancel)="onCancelSearch()"
      [nzFooter]="null" [nzWidth]="'80%'" >
      <ng-container *nzModalContent>
        <form nz-form>
          <div nz-row [nzJustify]="'space-between'">
            <div nz-col nzSpan="7">              
              <nz-form-item>
                <nz-form-label nzFor="incidentNumber">Breakdown Number</nz-form-label>
                <nz-form-control>
                  <input 
                    nz-input 
                    id="incidentNumber" 
                    [(ngModel)]="incidentSearchRequest.incidentNumber" 
                    name="incidentNumber" 
                    placeholder="Enter breakdown number" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="4">
              <nz-form-item>
                <nz-form-control>
                  <label nz-checkbox [(ngModel)]="incidentSearchRequest.closedIncidents" name="closedIncidents">
                    Include Closed Breakdowns
                  </label>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="10">
              <nz-form-item>
                <nz-form-label nzFor="dateRange">Date Range</nz-form-label>
                <nz-form-control>
                  <nz-range-picker 
                    id="dateRange" 
                    [(ngModel)]="dateRange" 
                    name="dateRange"
                    style="width: 100%;"
                    (ngModelChange)="onDateRangeChange($event)">
                  </nz-range-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          
          
          
          <nz-form-item>
            <nz-form-control>
              <button nz-button nzType="primary" (click)="onSearchIncident()" [nzLoading]="isSearchingForIncident">Search</button>
            </nz-form-control>
          </nz-form-item>
        </form>
        <nz-table [nzData]="incidentSearchResults" [nzLoading]="isSearchingForIncident">
          <thead>
            <tr>
              <th>Breakdown Number</th>
              <th>Client Name</th>
              <th>Vehicle / Driver</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (incident of incidentSearchResults; track incident.incidentId) {
            <tr>
              <td>{{ incident.incidentNumber }}</td>
              <td>{{ incident.clientName }}</td>
              <td>{{ incident.fleetVehicle.registrationNumber }} / {{ incident.driver.name }}</td>
              <td>{{ incident.status }}</td>
              <td>
                <button nz-button nzType="primary" (click)="onSelectIncident(incident)">Select</button>
              </td>
            </tr>
            }
          </tbody>
        </nz-table>
      </ng-container>
    </nz-modal>
